// extracted by css-extract-rspack-plugin
export default {"repositoriesListWrapper":"OrgReposListContent-module__repositoriesListWrapper__mHi9bUx"};